interface HeroProps {
  onOpenModal: () => void;
}

export default function Hero({ onOpenModal }: HeroProps) {
  return (
    <section id="top" className="container hero animate-fade-in">
      <div className="hero-copy">
        <span className="eyebrow">The AI spend benchmark</span>
        <h1>See where <span className="text-gradient">AI budgets</span> are going.</h1>
        <p>Compare how teams fund LLM infrastructure, API usage, and fine-tuning—using verified, anonymized submissions from across the industry.</p>
        <div className="hero-actions">
          <button className="btn btn-primary" onClick={onOpenModal}>Contribute your data <span>→</span></button>
          <button className="btn btn-secondary" onClick={() => document.getElementById('leaderboard')?.scrollIntoView({ behavior: 'smooth' })}>Explore benchmark</button>
        </div>
      </div>
      <div className="hero-image-frame">
        <img className="hero-image" src="/hero-v2.png" alt="Abstract visualization of AI token infrastructure and spend" />
        <div className="hero-stat"><strong>ANONYMOUS + VERIFIED</strong><span>Built for trustworthy comparisons</span></div>
      </div>
    </section>
  );
}
